import { render } from "./MainSuppliers.vue?vue&type=template&id=669299fa&scoped=true"
import script from "./MainSuppliers.vue?vue&type=script&lang=js"
export * from "./MainSuppliers.vue?vue&type=script&lang=js"

import "./MainSuppliers.vue?vue&type=style&index=0&id=669299fa&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669299fa"]])

export default __exports__